import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { User } from '../models/user';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiService = inject(ApiService);

  private currentUserSubject = new BehaviorSubject<User|null>(null);
  public currentUser = this.currentUserSubject.asObservable();

  login(params: any): Observable<any> {
    return this.apiService.post(`auth/login`, params)
      .pipe(
        map((response: { access_token: string }) => {
          localStorage.setItem(environment.accessTokenName, response.access_token);
        })
      );
  }

  getCurrentUser(): Observable<User> {
    return this.apiService.post(`auth/current`)
      .pipe(
        tap(
          (response: User) => {
            this.currentUserSubject.next(response);
          }
        )
      );
  }

  changePassword(params: any): Observable<any> {
    return this.apiService.post(`auth/password/reset`, params);
  }

  changePasswordRequest(params: any): Observable<any> {
    return this.apiService.post(`auth/password/request_email`, params);
  }

  logout(): Observable<any> {
    return this.apiService.post(`auth/logout`)
      .pipe(
        map(() => {
          localStorage.removeItem(environment.accessTokenName);
          this.currentUserSubject.next(null);
        })
      );
  }

}
